// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-e"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 5H9C8.44772 5 8 5.44772 8 6V12M8 12H16M8 12V18C8 18.5523 8.44772 19 9 19H16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersEIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-e',
    ref,
    icon: element,
  },
));

LettersEIcon.displayName = 'LettersEIcon';

export default LettersEIcon;
